// 域名获取
function convertDomain(currDomain) {
  var localDomain = window.location.host
  var name = localDomain.split('.', 2)[0]
  var arr = name.split('-', 2)
  return arr.length > 1 ? arr[0] + '-' + currDomain : '' + currDomain
}

// 进行配置
let address = 'https://' + convertDomain('rest.zhibo.tv')
let address2 = 'https://' + convertDomain('vip.zhibo.tv')
let address3 = 'https://' + convertDomain('static.zhibo.tv')
let address4 = 'http://' + convertDomain('vip.zhibo.tv')
let address5 = 'https://' + convertDomain('vip.sports.cctv.com')
const ADDRESS = {
  address,
  address2,
  address3,
  address4,
  address5
}
export{
  ADDRESS
}